import { render, staticRenderFns } from "./DisabledInput.vue?vue&type=template&id=08f5c51a&scoped=true&"
import script from "./DisabledInput.vue?vue&type=script&lang=js&"
export * from "./DisabledInput.vue?vue&type=script&lang=js&"
import style0 from "./DisabledInput.vue?vue&type=style&index=0&id=08f5c51a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f5c51a",
  null
  
)

export default component.exports